import { render, staticRenderFns } from "./SkeletonCourseDetails.vue?vue&type=template&id=68e563da&scoped=true"
import script from "./SkeletonCourseDetails.vue?vue&type=script&lang=js"
export * from "./SkeletonCourseDetails.vue?vue&type=script&lang=js"
import style0 from "./SkeletonCourseDetails.vue?vue&type=style&index=0&id=68e563da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e563da",
  null
  
)

export default component.exports